export default __webpack_public_path__ + "static/media/logo.5ec24a7d.png";